import type { Page } from '@efdigital/ll-addon-data';
import { debounce } from '@efdigital/ll-addon-ui/modifiers/debounce';
import {
  addClass,
  hasClass,
  removeClass,
} from '@efdigital/ll-addon-ui/utils/css-class-helpers';
import { EditRecord } from '@efdigital/ll-admin-v2/components/edit-record.gts';
import { type EditRecordSignature } from '@efdigital/ll-admin-v2/components/edit-record-base.gts';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { set } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { Store } from '@warp-drive/core';

export class EditPageContent extends Component<EditRecordSignature<Page>> {
  @service declare store: Store;

  setValue = (property: string, event: Event) => {
    const target = event.target as HTMLInputElement;
    set(this.args.item, property, target.value);
  };

  get showPageTitle(): boolean {
    return !hasClass(this.args.item.css ?? '', 'hide-page-title');
  }

  togglePageTitle = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const css = this.args.item.css ?? '';
    this.args.item.css = target.checked
      ? removeClass(css, 'hide-page-title')
      : addClass(css, 'hide-page-title');
  };

  <template>
    <EditRecord
      @editLabel="Edit Page Settings"
      @item={{@item}}
      @context={{@context}}
      @maxDepth={{2}}
      ...attributes
    >
      <:form as |uniqueId isDisabled|>
        <fieldset disabled={{isDisabled}} class="mb-4">
          <legend class="gud-eyebrow">Page Title</legend>

          <div class="form-group mb-3">
            <label
              for="{{uniqueId}}-title"
              class="form-label required visually-hidden"
            >Title</label>
            <input
              type="text"
              class="form-control"
              id="{{uniqueId}}-title"
              value={{@item.title}}
              required
              {{debounce (fn this.setValue "title")}}
            />
          </div>

          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="{{uniqueId}}-show-title"
              checked={{this.showPageTitle}}
              {{on "change" this.togglePageTitle}}
            />
            <label class="form-check-label" for="{{uniqueId}}-show-title">
              Show page title
            </label>
            <div class="form-text">
              Display the title on the page. The title is always shown in
              navigation.
            </div>
          </div>
        </fieldset>
      </:form>
    </EditRecord>
  </template>
}
